/**
 * Handing a file to the browser.
 *
 * The name comes from the API's `Content-Disposition`, so the convention lives in one place
 * (`app/report/naming.py`) instead of being reinvented here and drifting. The fallback is
 * deliberately plain: if it ever shows up in somebody's Downloads folder, it should be obvious
 * that the server did not name the file, rather than looking like a second convention.
 */

import type { DownloadedFile } from "../api/client";

export function saveFile(file: DownloadedFile, fallback: string): void {
  const url = URL.createObjectURL(file.blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = file.filename ?? fallback;
  document.body.appendChild(link);
  link.click();
  link.remove();
  // Revoking immediately can cancel the download in some browsers; a tick is enough.
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Only used when the API did not say. Digits of the CUIT, so at least the legajo is identifiable. */
export function fallbackReportName(cuit: string, format: string): string {
  return `informe-riesgo_${cuit.replace(/\D/g, "") || "legajo"}.${format}`;
}
